import { defineFormSchema } from '../../../shared/data/formSchema';
import { PERMISSION_ROLE_OPTIONS, OWNER_PERMISSION_OPTION, COMPANY_ROLE_OPTIONS, TEAM_TYPE_OPTIONS } from '../workspaceUsers.config';
export const formSchema = defineFormSchema({ id: 'workspace.user.invite', fields: [
  { name: 'fullName', label: 'Nome Completo' }, { name: 'email', label: 'Email', type: 'email' },
  { name: 'permissionRole', label: 'Permessi', type: 'select', options: [...PERMISSION_ROLE_OPTIONS, OWNER_PERMISSION_OPTION] },
  { name: 'teamType', label: 'Team', type: 'select', options: TEAM_TYPE_OPTIONS },
  { name: 'companyRole', label: 'Ruolo aziendale', options: COMPANY_ROLE_OPTIONS },
  { name: 'active', label: 'Stato', type: 'boolean' }, { name: 'inviteStatus', label: 'Invito' },
  { name: 'password', label: 'Password', type: 'password', sensitive: true },
  { name: 'confirmPassword', label: 'Conferma password', type: 'password', sensitive: true },
] });
